/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OWGameResponse,
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof InlineResponse20022
     */
    data?: Array<OWGameResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InlineResponse20022
     */
    paginationInfo?: PaginationInfo;
}

export function InlineResponse20022FromJSON(json: any): InlineResponse20022 {
    return InlineResponse20022FromJSONTyped(json, false);
}

export function InlineResponse20022FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20022 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(OWGameResponseFromJSON)),
        'paginationInfo': !exists(json, 'paginationInfo') ? undefined : PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function InlineResponse20022ToJSON(value?: InlineResponse20022 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(OWGameResponseToJSON)),
        'paginationInfo': PaginationInfoToJSON(value.paginationInfo),
    };
}


